/**
 * Режимы блока «Подписанты» внутри акта / решения (есть parentName).
 */
export enum NestedSignersModeEnum {
  /** Новый акт/решение: кнопка доступна, максимум 1 запись */
  NEW_SINGLE = 'NEW_SINGLE',
  /** firstExtractDateTime && !signed: несколько записей, первая только чтение */
  MULTI_FIRST_LOCKED = 'MULTI_FIRST_LOCKED',
  /** Кнопка «Добавить» скрыта */
  ADD_HIDDEN = 'ADD_HIDDEN',
}
